const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const APPLE_PRIVATE_RELAY_SUFFIX = '@privaterelay.appleid.com';

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value);
}

export function isApplePrivateRelayEmail(value: string): boolean {
  return value.toLowerCase().endsWith(APPLE_PRIVATE_RELAY_SUFFIX);
}
